import { each, isEmpty, mapValues, pick, sum } from 'lodash';
import { isSameMonth } from 'date-fns';
import * as Yup from 'yup';
import { price } from 'utils/helpers';

export const successColor = '#198754';

export function getLabels(currentMonth, pricingList) {
  let labels = [];

  if (!pricingList) {
    return;
  }

  let rawPriceArray = [];
  each(pricingList, (value, key) => {
    if (
      value.available &&
      value.pricing_details &&
      (currentMonth ? isSameMonth(new Date(key), currentMonth) : true)
    ) {
      const priceValue =
        value.pricing_details.minimum_price_with_adjustments_in_cents;
      rawPriceArray.push(priceValue);
      labels.push({
        start: key,
        rawPrice: priceValue,
        title: price(priceValue, {
          fromCents: true,
          omitZeroCents: true,
        }),
      });
    }
  });
  // Set the label of cheapest date to green
  rawPriceArray = [...new Set(rawPriceArray)];
  const minPrice = Math.min(...rawPriceArray);
  labels = labels.map((label) => {
    const { rawPrice } = label;
    delete label.rawPrice;
    if (rawPrice === minPrice && rawPriceArray.length > 1) {
      label.textColor = successColor;
    }
    return label;
  });
  return labels;
}

export const formSchema = ({
  independentPassengerTypes,
  soloChildWarningMessage,
}) =>
  Yup.lazy((value) => {
    const rules = {
      resource: Yup.number().required('Please select a resource'),
      date: Yup.date().required('Please select a date'),
      passengers: Yup.lazy((obj) =>
        Yup.object(mapValues(obj, () => Yup.number())).test({
          name: 'passenger-validation',
          test(passengers) {
            const count = sum(Object.values(passengers));

            if (count < 1) {
              return this.createError({
                message: `You must have at least 1 passenger`,
              });
            }

            if (!isEmpty(independentPassengerTypes)) {
              const elder = pick(passengers, independentPassengerTypes);
              if (sum(Object.values(elder)) <= 0) {
                return this.createError({
                  message:
                    soloChildWarningMessage ||
                    'You must at least have one adult.',
                });
              }
            }

            return true;
          },
        })
      ),
      extraPicks: Yup.array().of(Yup.number().integer()),
    };

    if (value.showBedding) {
      rules.bedRequirement = Yup.number().required('Please select a bedding');
    }

    return Yup.object().shape(rules);
  });
